import React from "react";
import PropTypes from "prop-types";
import { Icon, IconNames } from "@wattpad/web-ui-library";

import { useTrans, useGetUser, useFeatureFlags } from "../../../hooks";

const ReadingListVisibilityIcon = ({ visibility, user }) => {
  const { trans } = useTrans();
  const currentUser = useGetUser();
  const featureFlags = useFeatureFlags();

  const isOwner = !!(user && currentUser && user.name === currentUser.username);
  const isFeatureEnabled = !!(
    featureFlags && featureFlags.IS_PRIVATE_READING_LISTS
  );

  if (!isOwner || !isFeatureEnabled) {
    return null;
  }

  const isPublic = visibility === "public";

  return (
    <span className="visibility-icon">
      <Icon
        name={isPublic ? IconNames.WpPublic : IconNames.WpLock}
        size={16}
        ariaLabel={isPublic ? trans("Public") : trans("Private")}
      />
    </span>
  );
};

ReadingListVisibilityIcon.propTypes = {
  visibility: PropTypes.string,
  user: PropTypes.shape({
    name: PropTypes.string
  })
};

export default ReadingListVisibilityIcon;
